import AppUtils from '@/utils/AppUtils'
import { mapGetters, mapState, mapMutations } from 'vuex'
import dot from 'dot-object'

export default {
  data(){
    return {
    }
  },
  methods: {
    imgUrlAlt(event){
      event.target.src = this.imagePlaceholder
    },
    imgSrcHandler(src,query={}){
      if (src === undefined || src === null) return this.imagePlaceholder
      return this.fileModifier(src,query ) ?? this.imagePlaceholder
    },
    fileModifier (url, query) {
      try {
        const urlObj = new URL(url)
        Object.keys(query).forEach(key => urlObj.searchParams.append(key, query[key]))
        return urlObj.toString()
      } catch (e) {
        return url
      }
    },
    ...mapMutations('App', [
      'SET_APP_BREADCRUMBS',
      'ADJUST_APP_LOADING',
      'SET_APP_HEADER_TITLE',
      'SET_APP_HEADER_COLOR',
      'SET_APP_DOCUMENT_TITLE',
      'SET_APP_FULL_SCREEN',
      'SET_APP_SUB_HEADER'
    ]),
    toggleAppTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },
    appAllowAccess (authenticated = false, roles = [], permissions = []) {
      return AppUtils.allowAccess(authenticated, roles, permissions)
    },
    appToggleFullScreen (element = 'html') {
      AppUtils.toggleFullScreen(element)
    },
    getError (name, error) {
      return error[name] ?? dot.pick(name, error)
    },
    nextInput (elem) {
      if ((elem?.keyCode === 13 || elem?.keyCode === 40) && elem?.target?.form) {
        const currentIndex = Array.from(elem.target.form).indexOf(elem.currentTarget)
        elem.target.form[
          currentIndex < elem.target.form.length - 1
            ? currentIndex + 1
            : 0
        ].focus()
      }
    },
    fileSrc (val) {
      return val ? `${this.$API_URL}download.api?path=${val}` : undefined
    },
    openNewTab (input) {
      if(typeof input === 'string') return window.open(input, '_blank')
      // if input is not object throw error
      if (typeof input !== 'object') throw new Error('openNewTab only accept object as input')

      console.log(this.$router.resolve(input))
      const routeData =  this.$router.resolve(input);
      window.open(routeData.href, '_blank');
    },
    mCss(css, classes, isId=false){
      if(isId){
        if(typeof classes === 'string') classes = classes.split(' ')
        let output = []
        for (let i = 0; i < css.length; i++){
          output = [...output, ...classes.map(c => css[i][c])]
        }
        // filter out null
        output = output.filter(c => c).join('')

        if(output.length>0) return output
        else return classes.join('')
      }


      // if class is string, eg: 'class1 class2'
      // convert to array of class, eg: ['class1', 'class2']
      if(typeof classes === 'string') classes = classes.split(' ')
      // if class is object, eg: {class1: true, class2: false}
      // convert to array of class, eg: ['class1']
      // if(typeof classes === 'object') classes = Object.keys(classes).filter(c => classes[c])

      // if css is array of object
      if(Array.isArray(css)){
        let output = []
        for (let i = 0; i < css.length; i++){
          output = [...output, ...classes.map(c => css[i][c])]
        }
        // filter out null
        output = output.filter(c => c)
        return output;
      }
      // if css is object
      if(typeof css === 'object'){
        return classes.map(c => css[c])
      }
      throw new Error('css must be an object or an array of object')
    },
    /**
     * when user need login to access page
     */
    goToLoginPage(){
      const currentRoute = this.$route.fullPath
      this.$router.push({ name: 'Login', query: { next: currentRoute } })
    },

    formConverter(baseDef){
      const result = []

      const map ={
        enum: 'select',
        number: 'number',
        longtext: 'textarea',
        file: 'file'
      }

      for (const key in baseDef) {
        const element = baseDef[key];

        const item = {
          label: element.label,
          data: element.data ?? key,
          type:  map[element.type],
          column: 'col-12',
          rules: element.required?'required':'',
          props:{}
        }
        if(element.type === 'enum'){
          item.props.items = element.items
        }
        if(element.show){
          item.show = element.show
        }
        result.push(item)
      }
      return result
    },
    readConverter(baseDef,data){
      const result = []
      const map ={
        enum: 'chip',
        number: 'text',
        longtext: 'longtext',
        file: 'files'
      }

      for (const key in baseDef) {
        const element = baseDef[key];

        const item = {
          label: element.label,
          value: data[key],
          type:  map[element.type],
        }
        if(element.type === 'enum'){
          item.items = element.items
        }

        if(element.data){
          item.value = element.data.get(data)
        }

        // if readShow is set override show
        if(element.readShow !== undefined) element.show = element.readShow

        // show
        if (element.show === undefined) item.show = true
        // if show is boolean
        if (typeof element.show === 'boolean') item.show = element.show
        // if show is function
        if (typeof element.show === 'function') item.show = element.show(data)


        if(item.show){
          result.push(item)
        }
      }
      return result
    }
  },
  computed: {
    ...mapGetters('App', [
      'getAppLoading',
      'getAppHeaderTitle',
      'getAppHeaderColor',
      'getAppDocumentTitle',
      'getAppFullScreen'
    ]),
    ...mapState('App', ['appBreadcrumbs']),
    isAppDebugMode () {
      return AppUtils.isDebugMode()
    },
    console: () => console
  },
  beforeRouteEnter (to, _from, next) {
    next((vm) => {
      const targetName = to.meta.title ?? to.name
      vm.SET_APP_HEADER_TITLE(to.meta.headerTitle ?? targetName)
      vm.SET_APP_DOCUMENT_TITLE((to.meta.documentTitle ?? targetName) + ' - ' + import.meta.env.VITE_APP_TITLE)
      if(vm.post_beforeRouteEnter) {
        vm.post_beforeRouteEnter(to, _from, next)
      }
    })
  },
  mounted () {
    /**
     * Dirty fix for image not found
     */
    const imgs = document.querySelectorAll('img')
    imgs.forEach(img => {
      // set background image when loading
      // img.style.backgroundImage = `url(${this.imagePlaceholder})`
      // img.addEventListener('load', () => {
      //   img.style.backgroundImage = 'none'
      // })

      // img.addEventListener('error', this.imgUrlAlt)
    })
  }
}
